import axios from 'axios';
import { clearAuthAndRedirect } from '@/entities/Admin';
import { LocalStorageService } from '@/shared/services/localStorage.service';

export const $api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true,
});

$api.interceptors.request.use(
  (config) => {
    const accessToken = LocalStorageService.getAccessToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// 401 — сессии нет (токен протух или отозван): выход. 403 — сессия действительна, но действие
// запрещено (нет раздела, чужая запись, заблокированный аккаунт при входе): ошибку показывает
// вызывающий код, пользователь остаётся в системе.
$api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      clearAuthAndRedirect('/login');
    }
    return Promise.reject(error);
  },
);
